"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var AXSFlex_1 = __importDefault(require("../../layout/AXSFlex"));
var AXSFormField_1 = __importDefault(require("../AXSFormField"));
var Div = styled_components_1.default(AXSFlex_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.c-axs-form-group {\n    margin-top: 24px;\n\n    &:first-of-type {\n      margin-top: 0;\n    }\n  }\n\n  .c-axs-form-field {\n    width: 100%;\n  }\n\n  .c-axs-form-field + .c-axs-form-field {\n    margin-left: ", ";\n    margin-top: ", ";\n  }\n"], ["\n  &.c-axs-form-group {\n    margin-top: 24px;\n\n    &:first-of-type {\n      margin-top: 0;\n    }\n  }\n\n  .c-axs-form-field {\n    width: 100%;\n  }\n\n  .c-axs-form-field + .c-axs-form-field {\n    margin-left: ", ";\n    margin-top: ", ";\n  }\n"])), function (_a) {
    var inline = _a.inline;
    return inline ? '30px' : '0';
}, function (_a) {
    var inline = _a.inline;
    return !inline ? '24px' : '0';
});
var AXSFormGroup = function (_a) {
    var inline = _a.inline, className = _a.className, children = _a.children, props = __rest(_a, ["inline", "className", "children"]);
    return (React.createElement(Div, __assign({ flexWrap: inline ? 'nowrap' : 'wrap', inline: inline }, props, { className: classnames_1.default(['c-axs-form-group', className]) }), React.Children.map(children, function (child) {
        return React.createElement(AXSFormField_1.default, __assign({ label: child.props.label, extra: child.props.extra, readOnly: child.props.readOnly, caption: child.props.caption, error: child.props.error }, props, { width: "100%" }), child.props.children);
    })));
};
AXSFormGroup.defaultProps = {
    required: false,
};
exports.default = AXSFormGroup;
var templateObject_1;
//# sourceMappingURL=index.js.map